import { api } from '../index';

export const graphData = id => api.get(`/bar-graph/${id}`);
